import { useNavigate } from 'react-router-dom'
import useSWR from 'swr'

import { useI18N } from '../../../libraries/i18n/hook'
import PreferencesForm from '../../containers/users/PreferencesForm'
import OnBoardingHeader from './Header'
import { getUserPreferences } from '../../../api/users'
import Loading from '../../components/layout/Loading'

const OnboardingPreferences = () => {
  const { t } = useI18N()
  const { data, isLoading } = useSWR('/users/preferences', getUserPreferences)
  const navigate = useNavigate()
  const onSuccess = () => {
    navigate('/onboarding/news')
  }

  if(isLoading) {
    return <Loading />
  }
  return (
    <>
      <OnBoardingHeader title={t('onboarding.preferences.title')} description={t('onboarding.preferences.description')} />
      <PreferencesForm defaultValues={data} onSuccess={onSuccess} />
    </>
  )
}
export default OnboardingPreferences
